$mol_icon_equalizer $mol_icon path \M10,20H14V4H10V20M4,20H8V12H4V20M16,9V20H20V9H16Z
